import constants from 'core/types'
import { takeEvery, call, put } from 'redux-saga/effects'
import { JsonRpcProvider, BrowserProvider }  from 'ethers'
import { getContractAddressFromChainId } from 'core/libs/lib-rpc-helpers'

export function* setProvider() {
  try {
    //const isMetaMaskUnLocked = yield call([window.ethereum._metamask,'isUnlocked'])
    
    const accounts= yield call(window.ethereum.request, {method: 'eth_accounts', "params": []})     
    const metaMaskAccount= accounts[0] 

    const retrievedChainId= yield call(window.ethereum.request, { method: "eth_chainId" })
    const chainId = parseInt(retrievedChainId, 16)

    /* Only set the provider if MetaMask is unlocked */
    if(accounts && accounts.length > 0) {  
      let web3Provider
      
      if(chainId === 1337) {
        const localNodeUrl = "http://localhost:8545" 
        web3Provider = new JsonRpcProvider(localNodeUrl) // Instantiate an ethers JsonRpcProvider instance
      } else {
        web3Provider= new BrowserProvider(window.ethereum)
      }
      
      //const accounts= yield call(window.ethereum.request, {method: 'eth_accounts', "params": []})     
      //const metaMaskAccount= accounts[0]    
      const signer= yield call([web3Provider,'getSigner'])
      const contractAddress = getContractAddressFromChainId(parseInt(chainId, 16))
      
      console.log('--- chain ID: ', chainId)
      console.log('--- deployed contract address used is: ', contractAddress)
      
      yield put({ type: constants.CLOSE_RIGHT_DRAWER })
  
      yield put({
        type: constants.SET_PROVIDER,
        payload: { 
          web3Provider,
          metaMaskAccount,
          signer,
          chainId
        }
      })
    }
  } catch (error) {
    console.log(" errorz is: ....", error)
  }
}


export function* setChainId(action) {
  const { chainId } = action

  try {
    let chainId_

    if(chainId) {
      chainId_ = chainId
    } else {
      chainId_ = yield call(window.ethereum.request, { method: "eth_chainId" })    
    }
  
    yield put({
      type: constants.SET_CHAIN_ID,
      payload: { 
        chainId: parseInt(chainId_, 16)
      }
    })
  } catch (error) {
    console.log('------- setChainId error iz: ------', error)
    console.log(error)
  }
}

export function* connectMetaMask() {
  if(window && window.ethereum) {
      try {
        const metaMaskConnection = yield call(window.ethereum.request, {
          "method": "eth_requestAccounts",
          "params": []
        })
        const metaMaskAccount = metaMaskConnection[0] 
        yield put({
          type: constants.SET_METAMASK_CONNECTION,
          payload: { metaMaskAccount }
        })
        yield put({ type: constants.CLOSE_RIGHT_DRAWER })
      } catch (error) {
        console.log(error)
        if (error.code === -32002) { // MetaMask error code for 'Already processing eth_requestAccounts'
          console.warn("MetaMask is already processing a connection request. Please wait or interact with the MetaMask prompt.");
          // Display a user-friendly message to the user
        } else {
          console.error("Error connecting to MetaMask:", error);
          // Handle other connection errors
        }
      }
  } else {
    yield put({ 
      type: constants.OPEN_MODAL,
      payload: { modalKey: 'install-metamask-prompt' }
    })
  }
}

export function* watchProviderActions() {
  yield takeEvery(constants.INIT_PROVIDER, setProvider),
  yield takeEvery(constants.INIT_CHAIN_ID, setChainId)
  yield takeEvery(constants.CONNECT_METAMASK, connectMetaMask)
}
